export default function (data:Record<string, any> = {}) {
    return [
        {
            label:'姓名',
            placeholder:'请输入姓名',
            key:'name',
            rules:{
                empty:'请输入姓名'
            }
        },
        {
            label:'单位',
            placeholder:'请输入单位名称',
            key:'company',
            rules:{
                empty:'请输入单位名称'
            }
        },
        {
            label:'职务',
            placeholder:'请输入职务',
            key:'job',
            rules:{
                empty:'请输入职务'
            }
        },
        {
            label:'邮箱',
            placeholder:'请输入邮箱',
            key:'email',
            rules:{
                empty:'请输入邮箱'
            }
        },
        {
            label:'手机号',
            placeholder:'请输入手机号',
            key:'phone',
            type:'number',
            rules:{
                empty:'请输入手机号',
                mobile:'手机号格式不正确'
            }
        },
        {
            label:'短信验证',
            placeholder:'请输入短信验证',
            key:'code',
            rules:{
                empty:'请输入短信验证'
            },
            type:'number',
            code:'phone'
        }
    ].map((item)=>{
        return item;
    });
}

export const footerInput  = function () {
    return [
        {
            label:'您是否愿意戴尔科技集团联系您为您提供IT产品及解决方案的技术咨询与服务？',
            key:'is_ok',
            data:[
                {
                    value:1,
                    label:'愿意'
                },
                {
                    value:2,
                    label:'不愿意'
                }
            ],
            // rules:{
            //     empty:'您是否愿意戴尔科技集团联系您为您提供IT产品及解决方案的技术咨询与服务？'
            // },
            component:'radio',
            change(value:number,index:any,item:any,data:any){
                data[index+1].draw=value === 1;
            }
        },
        {
            label:'您愿意以何种方式收到相关信息？',
            key:'type',
            draw:false,
            data:[
                {
                    value:1,
                    label:'电话'
                },
                {
                    value:2,
                    label:'邮箱'
                },
                {
                    value:3,
                    label:'两者都行'
                }
            ],
            value:3,
            // rules:{
            //     empty:'您愿意以何种方式收到相关信息？'
            // },
            component:'radio'
        }
    ]
}
